import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
const Addsonsectionlink = () => {
    const [name, setName] = useState('');
    const [photo, setPhoto] = useState('');
    const [link_id, setLink_id] = useState('');
    let navigt = useNavigate();
    let {id}=useParams();


    const  formSubmit = (e)=>{
            e.preventDefault()
            axios.post(`https://backend.dasta.net/api/auth/addworksectionsonControllerlink`,{
                name,
                photo,
                link_id,
            }).then((data)=>{
                navigt(-1);
            })
        }  
    return(
        
        <>
            <form onSubmit={formSubmit}>
                <label for="fname" >Enter Link:</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setName(e.target.value)}/>
                <label for="fname" >Enter descrption:</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setPhoto(e.target.value)}/>
                
                <label for="fname" >Enter This Number::{id}</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setLink_id(e.target.value)}/>
                
                <button type='submit' >add</button>
             </form> 
        </>
        
    )
}
export default Addsonsectionlink;